import { render, staticRenderFns } from "./RateAgentOverall.vue?vue&type=template&id=0ac2e12d&scoped=true&"
import script from "./RateAgentOverall.vue?vue&type=script&lang=js&"
export * from "./RateAgentOverall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac2e12d",
  null
  
)

export default component.exports